export class StringHelpers {
  /**
   * isNumeric tests a string and returns true when it's a decimal value
   */
  static isNumeric = (val: string) => !isNaN(+val);

  /**
   * capitaliseFirstLetter capitalises only the very first character of a string, leaving the
   * rest unedited
   */
  static capitaliseFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);
}


export const generateQueryString = function(query: Record<string, string>) {
  const params = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    if (query[key] !== void 0) {
      params.set(key, query[key].toString());
    }
  });
  return `?${params.toString()}`;
};